import { COMPANY_LEVEL_STYLES } from '../constants';
import { normalizeCompanyLevel } from './companyLevel';

export const getCompanyLevelStyles = (level?: string | null) =>
  COMPANY_LEVEL_STYLES[normalizeCompanyLevel(level)];
